import { render, staticRenderFns } from "./app-install-template.vue?vue&type=template&id=28d5ba13&"
import script from "./app-install-template.vue?vue&type=script&lang=js&"
export * from "./app-install-template.vue?vue&type=script&lang=js&"
import style0 from "./app-install-template.vue?vue&type=style&index=0&id=28d5ba13&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports